import { useIntl } from 'react-intl';

import {
	ProductGrid,
	useProductData,
	ProductCategory,
	ProductItem,
	categories,
} from '../product-subnav';

import { MobileNavTitle } from './mobile-nav-card';

export const MobileNavProductProductManagers = () => {
	const intl = useIntl();
	const { productsByTag } = useProductData();
	const productManagersProducts = productsByTag[ProductCategory.ProductManagers] || [];

	return (
		<div>
			<MobileNavTitle
				title={intl.formatMessage(categories[ProductCategory.ProductManagers].title)}
			/>
			<ProductGrid>
				{productManagersProducts.map((product) => (
					<ProductItem key={product.id} {...product} />
				))}
			</ProductGrid>
		</div>
	);
};
